import { createSlice } from '@reduxjs/toolkit';
import { startLoadingEvents } from './timelineSlice';
import moment from 'moment';

export const actionsSlices = createSlice({
  name: 'actions',
  initialState: {
    message: null,
    actions: [],
    activeActions: null,
    lastUpdatedAction: null,
    lastAction: null,
    isLoading: true,
  },
  reducers: {
    startLoadingActions: (state /* action */) => {
      state.isLoading = true;
    },
    setAllActions: (state, { payload }) => {
      state.isLoading = false;
      state.message = payload.message;
      state.actions = payload.actions
        ?.slice()
        .sort(
          (a, b) =>
            moment(new Date(b.when_created)) - moment(new Date(a.when_created)),
        );
      state.activeActions = state.actions?.filter(
        (f) => f.action_status === null,
      ).length;
    },
    setLastUpdatedAction: (state, { payload }) => {
      state.lastUpdatedAction = payload.updatedAction;
      state.lastAction = payload.actionId;
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoadingActions, setAllActions, setLastUpdatedAction } =
  actionsSlices.actions;
